import { TRAPillButton } from "../visual";
import styles from "./guidance.module.css";

/**
 * Renders primaryAction (+ optional secondaryActions). Presentation only.
 * Parent handles intent via onAction(action).
 *
 * @param {{
 *   primaryAction?: { id?: string, intent?: string, label?: string, reason?: string, href?: string | null } | null,
 *   secondaryActions?: Array<{ id?: string, intent?: string, label?: string, reason?: string, href?: string | null }>,
 *   onAction?: (action: object) => void,
 *   primaryLoading?: boolean,
 * }} props
 */
export default function NextActionCard({
  primaryAction,
  secondaryActions = [],
  onAction,
  primaryLoading = false,
}) {
  if (!primaryAction?.label) return null;

  const secondaries = Array.isArray(secondaryActions)
    ? secondaryActions.filter((a) => a?.label)
    : [];

  return (
    <section
      className={styles.nextCard}
      aria-labelledby="guidance-next-action-title"
      data-testid="guidance-next-action-card"
    >
      <p className={styles.nextEyebrow}>Next action</p>
      <h3 id="guidance-next-action-title" className={styles.nextTitle}>
        {primaryAction.label}
      </h3>
      {primaryAction.reason ? (
        <p className={styles.nextReason}>{primaryAction.reason}</p>
      ) : null}
      <TRAPillButton
        type="button"
        variant="cta"
        className={styles.nextPrimary}
        disabled={primaryLoading}
        aria-busy={primaryLoading || undefined}
        data-testid="guidance-primary-cta"
        data-intent={primaryAction.intent || undefined}
        onClick={() => onAction?.(primaryAction)}
      >
        {primaryLoading ? "Working…" : primaryAction.label}
      </TRAPillButton>
      {secondaries.length ? (
        <div className={styles.nextSecondary} data-testid="guidance-secondary-actions">
          {secondaries.map((action) => (
            <TRAPillButton
              key={action.id || action.intent || action.label}
              type="button"
              variant="outline"
              className={styles.nextSecondaryBtn}
              data-intent={action.intent || undefined}
              onClick={() => onAction?.(action)}
            >
              {action.label}
            </TRAPillButton>
          ))}
        </div>
      ) : null}
    </section>
  );
}
